
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { InventoryTable } from "@/components/inventory/InventoryTable";
import { InventoryHeader } from "@/components/inventory/InventoryHeader";
import { InventoryStats } from "@/components/inventory/InventoryStats";
import { AddItemDialog } from "@/components/inventory/AddItemDialog";
import { InventoryItem, useInventoryStore } from "@/store/api/inventoryStore";
import { useIsMobile } from "@/hooks/use-mobile";
import { useDraftResumeToast } from "@/hooks/useDraftResumeToast";

const Inventory = () => {
  const { t } = useTranslation(["inventory", "common", "appui"]);
  const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
  const { items, fetchInventory, isLoading } = useInventoryStore();

  // Saisie article interrompue par un reload → proposer de la reprendre.
  useDraftResumeToast([
    {
      formId: "add-item",
      message: t("inventory.unsavedDraft", { ns: "appui" }),
      description: (d) => (d.name as string) || undefined,
      isEmpty: (d) => !(d.name || d.size),
      onResume: () => setIsAddDialogOpen(true),
    },
  ]);
  const isMobile = useIsMobile();

  useEffect(() => {
    fetchInventory();
  }, [fetchInventory]);

  const handleAddItem = () => {
    setIsAddDialogOpen(true);
  };

  // Map items to the format expected by InventoryStats and handle category type
  const formattedItems: InventoryItem[] = items.map(item => ({
    id: item.id,
    name: item.name,
    category: item.category as "suits" | "equipment" | "accessories",
    size: item.size || '',
    price: item.price,
    stock: item.stock,
    available: item.available,
    reserved: item.reserved,
    lastUpdated: item.lastUpdated || new Date().toISOString()
  }));

  return (
    <div className="flex flex-col flex-1 w-full">
      <div className={`flex-1 space-y-2 md:space-y-4 ${isMobile ? "p-2" : "p-4 md:p-8 pt-6"}`}>
        <InventoryHeader onAddItem={handleAddItem} />
        
        <InventoryStats items={formattedItems} />
        
        <InventoryTable />
        
        <AddItemDialog open={isAddDialogOpen} onOpenChange={setIsAddDialogOpen} />
      </div>
    </div>
  );
};

export default Inventory;
